import { useState } from 'react'
import { useApi } from '../../hooks/useApi'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { base64MimeType, getTextFile } from "../../helpers/functionsHelps"

const MySwal = withReactContent(Swal);

export default function StepperControl({ handleClick,
    currentStep, setOpenModal, xmlData, error, setError, setErrorMsg,
    setObjXml, infoAdicional, objXml, setUpdateEntrada, setCheckCCe, file, setFile }) {

    const [loading, setLoading] = useState(false);
    const api = useApi();

    const handleClickNext = async () => {
        try {
            setError(false);
            switch (currentStep) {
                case 1:
                    {
                        setLoading(true);
                        if (xmlData == null) {
                            setError(true);
                            setErrorMsg("Favor selecionar o arquivo XML.");
                            break;
                        }

                        let xmlText = await getTextFile(xmlData.get("files"));

                        if (!xmlText.includes(localStorage.getItem("@Cliente:cnpj").replace(/\D/g, ""))) {
                            setError(true);
                            setErrorMsg("Esse XML não pertence ao seu CNPJ.");
                            break;
                        }

                        const fileUpload = await api.uploadXml(xmlData);

                        if (fileUpload.data == "JaCadastrado") {
                            setError(true);
                            setErrorMsg("XML já enviado.");
                            break;
                        }

                        if (fileUpload.data.produtos.length <= 0 || fileUpload.data.entrada.chaveAcesso == null) {
                            setError(true);
                            setErrorMsg("Arquivo XML inválido.");
                            break;
                        }

                        if (fileUpload.data.fornecedor.blingId == "" || !fileUpload.data.fornecedor.blingId) {
                            fileUpload.data.fornecedor.realizarCadastro = true;
                        }
                        setObjXml(fileUpload.data);
                        handleClick("next");
                    }
                    break;
                case 2:
                    {
                        if (!infoAdicional.dataPrevista || infoAdicional.dataPrevista == "Invalid date") {
                            setError(true);
                            setErrorMsg("Necessário informar a data prevista.");
                            break;
                        }

                        if (!infoAdicional.qtdVolumes || infoAdicional.qtdVolumes <= 0) {
                            setError(true);
                            setErrorMsg("Necessário informar a quantidade de volumes.");
                            break;
                        }

                        if (infoAdicional.qtdVolumes != infoAdicional.numVolumes && file == '') {
                            setError(true);
                            setErrorMsg("Quantidade de volumes informado diferente da NF, favor anexar carta de correção abaixo");
                            setCheckCCe(true);
                            break;
                        }

                        let objInfo = { ...objXml }

                        if (file != '' && base64MimeType(file) != 'application/pdf') {
                            setError(true);
                            setErrorMsg("Arquivo CCe inválido.");
                            setCheckCCe(true);
                            setFile('');
                            break;
                        } else {
                            objInfo.entrada.cartaCorrecaoBase64 = file;
                            setFile('');
                        }

                        objInfo.entrada.entregaPrevista = infoAdicional.dataPrevista;
                        objInfo.entrada.totalVolumesInformado = parseInt(infoAdicional.qtdVolumes);
                        setObjXml(objInfo);
                        handleClick("next");
                    }
                    break;
                case 3: {
                    setLoading(true);
                    let objCopy = { ...objXml };
                    let validado = true;
                    for (let i = 0; i < objCopy.produtos.length; i++) {
                        let item = objCopy.produtos[i];

                        if ((item.codigoProdutoBling == null || item.codigoProdutoBling == '') && item.codigoBlingNovo == null) {
                            validado = false;
                            setError(true);
                            setErrorMsg("Necessário informar o código Bling do Produto " + item.codigoProdutoNF);
                            break;
                        }

                        if (item.codigoBlingNovo != null) {
                            let produto = await api.getProduto(item.codigoBlingNovo);

                            if (produto == null || produto.data.retorno.produtos.length <= 0) {
                                validado = false;
                                setError(true);
                                setErrorMsg("Código Bling " + item.codigoBlingNovo + " Não localizado, favor verificar.");
                                break;
                            }

                            let objBling = { ...objXml };
                            objBling.produtos[i].codigoProdutoBling = item.codigoBlingNovo;
                            objBling.produtos[i].produtoBling = produto.data.retorno.produtos[0].produto;
                            delete objBling.produtos[i].codigoBlingNovo;
                            setObjXml(objBling);
                        }

                    }

                    if (validado == false) break;

                    let validaBling = await api.validaBling(objXml)

                    if (validaBling.data.entrada == null ||
                        validaBling.data.fornecedor == null ||
                        validaBling.data.produtos.length <= 0) {

                        setError(true);
                        setErrorMsg("Erro no servidor, tente novamente mais tarde.");
                        break;
                    }

                    setObjXml(validaBling.data);
                    handleClick("next");

                }
                    break;
                case 4:
                    setLoading(true);

                    let ret = await api.gravarEntrada(objXml);

                    if (ret.data.produtos.length <= 0 || ret.data.entrada.chaveAcesso == null) {
                        setError(true);
                        setErrorMsg("Erro no servidor, tente novamente mais tarde.");
                        break;
                    }

                    await MySwal.fire({
                        icon: 'success',
                        title: 'Entrada registrada com sucesso.',
                        text: 'Foi aberto o Ticket Nº ' + ret.data.entrada.ticketMovidesk + '. Estamos aguardando a entrega.',
                        confirmButtonColor: "#00948b"
                    });

                    setOpenModal();
                    setUpdateEntrada(true);
                    break;
            }
        }
        catch (err) {
            console.log(err);
            setError(true);
            setErrorMsg("Arquivo XML inválido.");
        }
        finally {
            setLoading(false);
        }

    };

    return (
        <div className="container flex justify-between mt-3 mb-8">
            <button
                className={`bg-white border-2 border-soulog-900 text-soulog-900 text-sm 
                font-semibold rounded-md px-5 py-2 ${currentStep === 1 ? "opacity-50 cursor-not-allowed" : null}`}
                onClick={() => handleClick()}
            >
                Voltar
            </button>

            <button
                className="bg-soulog-900 border-2 border-soulog-900 text-white text-sm font-semibold rounded-md px-5 py-2"
                onClick={handleClickNext}
                disabled={loading}
            >
                {loading &&
                    <svg role="status" class="inline mr-3 w-4 h-4 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB" />
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor" />
                    </svg>
                }

                {currentStep === 4 ? "Gravar entrada" : "Avançar"}

            </button>
        </div>
    )
}
